export const MACBOOK_DEVICES = [
  // MacBook (2006 - 2010)
  "A1181", // MacBook (Early 2006 - Mid 2009)
  "A1342", // MacBook (13-inch, Late 2009)

  // MacBook Air
  "A1237", // MacBook Air (Original 2008)
  "A1304", // MacBook Air (Late 2008 - Mid 2009)
  "A1369", // MacBook Air (13-inch, Late 2010)
  "A1370", // MacBook Air (11-inch, Late 2010)
  "A1465", // MacBook Air (11-inch, Mid 2012)
  "A1466", // MacBook Air (13-inch, Mid 2012)
  "A1932", // MacBook Air (Retina, 13-inch, 2018 - 2019)
  "A2179", // MacBook Air (Retina, 13-inch, 2020)
  "A2337", // MacBook Air (M1, 13-inch, 2020)

  // MacBook Pro (Pre-Retina)
  "A1150", // MacBook Pro (15-inch, 2006)
  "A1211", // MacBook Pro (15-inch, Core 2 Duo, 2006)
  "A1226", // MacBook Pro (15-inch, 2007)
  "A1260", // MacBook Pro (15-inch, Early 2008)
  "A1278", // MacBook Pro (13-inch, Mid 2009 - Mid 2012)
  "A1286", // MacBook Pro (15-inch, Late 2008 - Mid 2012)
  "A1297", // MacBook Pro (17-inch, Early 2009 - Late 2011)

  // MacBook Pro (Retina Display)
  "A1398", // MacBook Pro (Retina, 15-inch, Mid 2012 - Mid 2015)
  "A1425", // MacBook Pro (Retina, 13-inch, Late 2012 - Early 2013)
  "A1502", // MacBook Pro (Retina, 13-inch, Late 2013 - Early 2015)

  // MacBook Pro (Touch Bar and USB-C models)
  "A1706", // MacBook Pro (13-inch, 2016 - 2017, Touch Bar)
  "A1707", // MacBook Pro (15-inch, 2016 - 2017, Touch Bar)
  "A1708", // MacBook Pro (13-inch, 2016 - 2017, no Touch Bar)
  "A1989", // MacBook Pro (13-inch, 2018 - 2019, Touch Bar)
  "A1990", // MacBook Pro (15-inch, 2018 - 2019, Touch Bar)
  "A2159", // MacBook Pro (13-inch, 2019, Touch Bar)

  // MacBook Pro (M1 and M2 Series)
  "A2338", // MacBook Pro (13-inch, M1, 2020) / (13-inch, M2, 2022)
  "A2442", // MacBook Pro (14-inch, M1 Pro/Max, 2021)
  "A2485", // MacBook Pro (16-inch, M1 Pro/Max, 2021)
  "A2780", // MacBook Pro (14-inch, M2 Pro/Max, 2023)
  "A2784", // MacBook Pro (16-inch, M2 Pro/Max, 2023)

  // 12-inch MacBook (2015 - 2017)
  "A1534", // MacBook (Retina, 12-inch, 2015 - 2017)
];
